export const MONTH_NAMES = [
  'Januar',
  'Februar',
  'Mars',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Desember',
];

export const oxford = (arr: string[]) => {
  if (arr.length === 1) {
    return arr;
  } else if (arr.length === 2) {
    return arr.join(' og ');
  } else {
    return arr.join(', ').replace(/, ([^,]*)$/, ', og $1');
  }
};

export const getRandomIntInclusive = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// `date` is always "YYYY-MM-DD" (see api/calendar/route.ts), already resolved
// to the event's own local calendar day, so this is a plain local-date parse
// with no timezone conversion involved.
export const parseDate = (date: string) => {
  const [year, month, day] = date.split('-').map(Number);
  return new Date(year, month - 1, day);
};
